import { Breadcrumbs, IconButton, Link, Tooltip, Typography } from '@material-ui/core';
import { GridOverlay } from '@material-ui/data-grid';
import { Image, Reply } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import DataGridComp from '../../../Core/Grid';
import WIPDocumentsViewer from './viewer';
import GijgoGrid from '../../internal/dashboard';
import { Grid } from '@material-ui/core';
import ReportGijgoGrid from '../../internal/ReportsScreens/GijgoForReportsScreen';
import { SquareButton } from '../../../Core/FormInput/AppButton';
import ReactDOM from 'react-dom';
import { useMemo } from 'react';
import formatters from '../../../Core/Grid/inputFormatter';
import { useHistory } from 'react-router-dom';
import OtherJobSelector from '../../internal/dashboard/NewSalesDashboard/WorkFlow/more/OtherJobDocMovement';
import { moveDocToOtherJob, NewMoveDocToOtherJob } from '../../../Core/Service/workflowJobDocument-service';
import OtherJobSelectionToMoveDoc from '../../internal/workflow-job/more/OtherJobDocMovement';

const DocumentViewer = (props) => {
    const history = useHistory();

    const [state, setState] = useState({
        showViewer: false,
        focusedRow: null,
        showDocToOtherModal: false
    });

    const handleView = (show, row) => {
        setState((st) => ({
            ...st,
            showViewer: show,
            focusedRow: row
        }));
    };
    const handleDocToOtherModal = (show, row) => {
        setState((st) => ({
            ...st,
            showDocToOtherModal: show,
            focusedRow: row
        }));
    };

    const closedocToOtherModal = () => {
        setState((st) => ({
            ...st,
            showDocToOtherModal: false
        }));
    };

    const baseColumns = [
        {
            field: 'action',
            title: `Action`,
            width: '5%',
            filterable: false,
            sortable: false
        },
        {
            field: 'wipNumber',
            title: `WIP`,
            filterable: true,
            sortable: true,
            width: '90'
        },
        {
            field: 'registration',
            title: 'Vehicle Reg',
            filterable: true,
            sortable: true,
            width: '120'
        },
        {
            field: 'chassisNumber',
            title: 'Chassis Number',
            filterable: true,
            sortable: true,
            width: '200'
        },
        {
            field: 'customerName',
            title: `Customer`
        },
        {
            field: 'ocrDocumentName',
            title: `Document Type`
        },
        {
            field: 'headerRecordID',
            title: `Header ID`,
            hidden: true
        },
        {
            field: 'ocrDocumentID',
            title: `ocrDocumentID`,
            hidden: true
        },
        {
            field: 'dateDueIn',
            title: `Date Due In`,
            width: '120'
        },
        {
            field: 'documentID',
            title: `Document ID`,
            hidden: true
        },
        {
            field: 'createdAt',
            title: `Created At`,
            width: '180'
        },
        {
            field: 'createdBy',
            title: `Created By`
        },
        {
            field: 'document',
            title: `Document Name`,
            hidden: true
        },

        {
            field: 'branchShortName',
            title: `Branch`,
            width: '120'
        },
        {
            field: 'franchiseName',
            title: `Franchise`
        }
    ];

    const editButton = (field) => (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="space-evenly">
                <SquareButton
                    style={{
                        backgroundColor: '#183B68',
                        borderRadius: '20%',
                        width: '32px',
                        height: '32px',
                        textAlign: 'center',
                        padding: '0px 0px 0px 0px'
                    }}
                    onClick={() => handleView(true, record)}
                >
                    <Image fontSize="small" style={{ color: 'white' }} />
                </SquareButton>
                <SquareButton
                    style={{
                        backgroundColor: '#183B68',
                        borderRadius: '20%',
                        width: '32px',
                        height: '32px',
                        textAlign: 'center',
                        padding: '0px 0px 0px 0px'
                    }}
                    onClick={() => handleDocToOtherModal(true, record)}
                >
                    <Reply fontSize="small" style={{ color: 'white' }} />
                </SquareButton>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const handleRedirectToJobDetails = (row) => {
        if (row.headerRecordID && row.workflowID) {
            history.push(`/Job/${row.headerRecordID}/${row.workflowID}?ProcessId=${row.pid}`);
        } else {
            console.error('Missing headerRecordID or workFlowID');
        }
    };

    const wipRendererWrapper = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container onClick={() => handleRedirectToJobDetails(record)}>
                <span style={{ textDecoration: 'underline', cursor: 'pointer', fontWeight: 'bold' }}>{value}</span>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const moveToOtherJob = async (otherJobId) => {
        setState((st) => ({ ...st, loading: true, showDocToOtherModal: false }));
        const res = await moveDocToOtherJob(state.focusedRow.headerRecordID, otherJobId, state.focusedRow.ocrDocumentID, state.focusedRow.documentID, true);
        props.showToast(res.message);
        if (res.success) {
            setState((st) => ({ ...st, isReload: new Date() }));
            // pullHistoryAndSetState();
        }
    };

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];
        let actionCol = tempCols.find((element) => element.field === 'action');
        let wipCol = tempCols.find((element) => element.field === 'wipNumber');
        let dateDueInCol = tempCols.find((element) => element.field === 'dateDueIn');
        let createdAtCol = tempCols.find((element) => element.field === 'createdAt');

        if (actionCol) {
            actionCol.renderer = editButton({});
        }
        if (wipCol) {
            wipCol.renderer = wipRendererWrapper;
        }

        if (dateDueInCol) {
            dateDueInCol.renderer = (val) => formatters.DateFormatter(val);
        }

        if (createdAtCol) {
            createdAtCol.renderer = (val) => formatters.DateTimeFormatter(val);
        }

        return tempCols;
    }, []);

    const baseUrl = 'DocumentViewer/GetAllDocuments';

    return (
        <div>
            {state.showViewer && <WIPDocumentsViewer focusedRow={state.focusedRow} handleClose={() => handleView(false, null)} />}

            <div>
                <Breadcrumbs separator=">>" aria-label="breadcrumb" style={{ marginTop: '25px', marginLeft: '5px' }}>
                    <Link color="inherit" to={'/'}>
                        Home
                    </Link>
                    <Typography color="secondary" style={{ fontSize: '0.85rem' }}>
                        WIP Documents Viewer
                    </Typography>
                </Breadcrumbs>

                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <ReportGijgoGrid
                            dataConverter={(res) => ({
                                records: res?.data?.rows,
                                total: res?.data?.total
                            })}
                            columns={columns}
                            getUrl={baseUrl}
                            isReload={state.isReload}
                        />
                    </Grid>

                    {state.showDocToOtherModal && (
                        <OtherJobSelectionToMoveDoc
                            headerId={state.focusedRow.headerRecordID}
                            showToast={props.showToast}
                            onClose={closedocToOtherModal}
                            onProcess={moveToOtherJob}
                            isLoadingDoc={props.isLoadingDoc}
                        />
                    )}
                </Grid>
            </div>
        </div>
    );
};

export default DocumentViewer;
